export default __webpack_public_path__ + "static/media/route-lines-icon.993efd9b.svg";